import { createContext, useContext } from 'react';

export const ProgramSelectorStateContext = createContext();
export const ProgramSelectorDispatchContext = createContext();

export const useProgramSelectorStateContext = () => useContext(ProgramSelectorStateContext);
export const useProgramSelectorDispatchContext = () => useContext(ProgramSelectorDispatchContext);
